import React from "react";
import { useCountUp } from "../hooks/useCountUp";

// Eigen component, zodat tijdens het tellen alleen dit cijfer opnieuw tekent
// en niet het hele dashboard, zestig keer per seconde.
//
// format: hoe het getal op het scherm hoort te staan, bijv. formatCurrency
// voor bedragen. Zonder format komt het kale getal eruit.
const CountUp = ({ value, format }) => {
  const shown = useCountUp(value);
  return <>{format ? format(shown) : shown}</>;
};

export default CountUp;
